// extracted by mini-css-extract-plugin
export default {"inputTextSection":"style_inputTextSection__-h5y1"};